const DBConfig = {
  name: 'Glynt',
  version: 1,
  objectStoresMeta: [
    {
      store: 'tokenized',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'tokenizedID', keypath: 'tkID', options: { unique: false } },
        { name: 'documentID', keypath: 'docID', options: { unique: false } },
        { name: 'version', keypath: 'version', options: { unique: false } },
        { name: 'tokenized', keypath: 'tokenized', options: { unique: false } },
      ],
    },
  ],
};

export default DBConfig;
